<template>
    <div id="product-mass-action-form">
        <b-loading :active="loading"></b-loading>
        <top-section>
            Product Mass Update
            <template v-slot:buttons>
                <b-button tag="button" v-if="checkedRows.length"
                          type="is-primary"
                          class="is-uppercase"
                          label="Update Products"
                          rounded @click.prevent="submit"
                          outlined></b-button>
            </template>
        </top-section>

        <div class="section" v-if="!checkedRows.length">
            <b-notification
                type="is-warning"
                has-icon :closable="false">
                <p class="mb-3">There are no products choosen for mass action. Please go back to the products page and select some products.</p>
                <b-button tag="router-link" :to="{name: 'product.index'}" type="is-black" label="Go to Products" outlined></b-button>
            </b-notification>
        </div>

        <div class="section" v-if="checkedRows.length">
            Updating attributes for products: {{ productIds }}
        </div>

        <div class="section" v-if="checkedRows.length">
            <b-field horizontal label="Select Store">
                <b-select v-model="input.store_ids" expanded multiple>
                    <optgroup v-for="website in websites"
                              :key="`website-${website.id}`"
                              :label="website.name">
                        <option v-for="store in website.stores"
                                :key="`website-${website.id}-store-${store.id}`"
                                :value="store.id" v-text="store.name"></option>
                    </optgroup>
                </b-select>
            </b-field>

            <b-field v-for="attribute in attributes" :key="`attribute-field-${attribute.id}`" horizontal :label="attribute.name">
                <b-field>
                    <b-input v-model="input[attribute.code]" :type="inputTypeMapping[attribute.type]"></b-input>
                </b-field>
            </b-field>
        </div>

        <div class="section is-flex"  v-if="checkedRows.length">
            <b-button tag="button"
                      type="is-primary"
                      class="is-uppercase"
                      label="Update Products"
                      rounded style="margin-left: auto"
                      @click.prevent="submit"
                      outlined></b-button>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            checkedRows: {
                required: true,
                type: Array
            },
        },
        data() {
            return {
                attributes: [],
                inputTypeMapping: {
                    string: 'text',
                    text: 'textarea'
                },
                input: {
                    store_ids: [1]
                },
                websites: [],
                loading: true
            }
        },
        mounted() {
            if(this.checkedRows.length) {
                axios.get('/attribute/filter', {params: {entity_type: 'product', updatable: 0}})
                    .then(response => {
                        this.attributes = response.data;
                        this.loading = false
                    })
                axios.get('/website/index')
                    .then(response => {
                        this.websites = response.data;
                        this.loading = false
                    })
            } else {
                this.loading = false
            }
        },
        methods: {
            submit() {
                this.loading = true;
                this.input.product_ids = _.map(this.checkedRows, 'id').join(',')
                axios.patch('/product/mass/update', this.input)
                    .then(response => {
                        this.checkedRows = [];
                        this.$emit('update:checkedRows', this.checkedRows);
                        this.$buefy.snackbar.open({
                            message: response.data.message,
                            type: 'is-success',
                            position: 'is-bottom-right',
                            actionText: 'Ok',
                        })
                        this.$router.push({name: 'product.index'});
                        this.loading = false
                    })
                    .catch(error => {
                        this.$buefy.snackbar.open({
                            message: error.response.data.message,
                            type: 'is-success',
                            position: 'is-bottom-right',
                            actionText: 'Ok',
                        })
                        this.loading = false;
                    })
            }
        },
        computed: {
            productIds() {
                return _.map(this.checkedRows, 'sku').join(', ')
            }
        }
    }
</script>